import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";

export class FooterResponseApiModel extends BaseApiResponseModel {
  description: String;

  constructor(model: FooterResponseApiModel) {
    super(model);

    this.description = model?.description;
  }
}
